module.exports = __webpack_public_path__ + "img/type17.b0f01bb1.png";